import './old/platser-page'
import '../styles/page-platser.scss'